import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Utility } from '../../core/utils/utility';
import { Observable, Subject, concatMap, tap } from 'rxjs';
import { AuthService } from '../../auth/_services/auth.service';
import { SignalrService } from './signalr.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {


  pendingCount = 0;
  pendingCount$: Subject<number> = new Subject<number>();
  apiUrl: string = `${environment.apiUrl}/connection`;

  constructor(private http: HttpClient, authService: AuthService, signalR: SignalrService) {
    signalR.connectionEstablished.subscribe(x => {
      this.pendingCount++;
      this.pendingCount$.next(this.pendingCount);
    })

    if (authService.isAuthenticated && !(authService.isAdminOrOperator || authService.isTenantAdminOrOperator)) {
      this.getStats().subscribe();
    }
  }

  getById(id: any): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/${id}`);
  }

  get(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}`, { params: params });
  }

  getApproved(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}/mine/approved`, { params: params });
  }

  getStats() {
    return this.http.get<any>(`${this.apiUrl}/stats`)
      .pipe(
        tap(x => {
          this.pendingCount = x.pending;
          this.pendingCount$.next(x.pending);
        })
      );
  }

  changeStatus(id: string | null, approved: boolean) {
    if (approved)
      return this.http.patch(`${this.apiUrl}/approve/${id}`, {})
        .pipe(
          concatMap(_ => this.getStats())
        );

    return this.http.patch(`${this.apiUrl}/reject/${id}`, {})
      .pipe(
        concatMap(_ => this.getStats())
      );
  }

  getConnections(tableState: any = null) {
    if (tableState) {
      let params = Utility.tableStateToHttpParams(tableState);
      return this.http.get<any>(`${this.apiUrl}/mine`, { params: params });
    } else {
      return this.http.get<any>(`${this.apiUrl}/mine`);
    }
  }

  getMessages(userId: any) {
    return this.http.get<any>(`${this.apiUrl}/messages`);
  }

  block(userId: string) {
    return this.http.post(`${environment.apiUrl}/chatuser/block`, { userId });
  }

  unblock(userId: string) {
    return this.http.post(`${environment.apiUrl}/chatuser/unblock`, { userId });
  }

  delete(toUserId: any) {
    return this.http.delete(`${this.apiUrl}/${toUserId}`);
  }
}
